import { PARTNERS } from '../../client/lib/constants';
import { getLink } from '../../client/lib/marketplace';
import getContent from '../../client/lib/dictionaryFetcher';

let marketplacesInstance = null;

class Marketplaces {
  constructor(marketplaceConnectConfig = {}) {
    if (!marketplacesInstance) {
      marketplacesInstance = {};
      PARTNERS.forEach(name => {
        const config = marketplaceConnectConfig[name] || {};
        marketplacesInstance[name] = {
          active: true,
          key: name,
          name: getContent('merchanthub', `apps.${name}.title`),
          description: getContent('merchanthub', `apps.${name}.description`),
          link: getLink(name, marketplaceConnectConfig),
          type: 'marketplace',
          videoLink: config.video_link
        };
      });
    }

    return marketplacesInstance || {};
  }

  static instance() {
    return marketplacesInstance || {};
  }

  static init(marketplaceConnectConfig) {
    new Marketplaces(marketplaceConnectConfig);
  }
}

export default Marketplaces;
